import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Typography } from "@mui/material";
import { getTimeOnlyString } from "../helpers/weather-helpers";
import { HourlyWeather, weatherCodes } from "../types/Weather";

const HourlyWeatherSlider = ({ hourlyWeather }: { hourlyWeather: HourlyWeather[] }) => {
  return (
    <Box sx={{ display: 'flex', overflowX: 'scroll' }}>
      {
        hourlyWeather.map((eachHour) => {
          const eachHourWeatherCode = weatherCodes.get(eachHour.weathercode);

          return (
            <Box sx={{ flexBasis: '10px', flexShrink: 0, paddingY: 2, paddingX: 2, textAlign: 'center' }} key={eachHour.time}>
              <Typography variant="body1">{eachHour.temperature_2m.toFixed(0)}°</Typography>
              <div>
                <FontAwesomeIcon
                  style={{ marginTop: 12, marginBottom: 5 }}
                  icon={eachHour.is_day ? eachHourWeatherCode?.dayIcon! : eachHourWeatherCode?.nightIcon!}
                  size="1x" />
              </div>
              <Typography variant="caption">{getTimeOnlyString(eachHour.time)}</Typography>
            </Box>
          )
        })
      }
    </Box>
  );
}

export default HourlyWeatherSlider;